import asset_0 from "../assets/icons/phone-icon.svg";
import asset_1 from "../assets/icons/arrow-right.svg";
import asset_2 from "../assets/icons/download-icon.svg";
import asset_3 from "../assets/icons/circle-yellow.svg";
import asset_4 from "../assets/icons/vector-gray.svg";
import asset_5 from "../assets/icons/vector-orange.svg";
import asset_6 from "../assets/icons/rectangle-yellow.svg";
import asset_7 from "../assets/icons/circle-purple.svg";
import asset_8 from "../assets/icons/vector-red.svg";
import asset_9 from "../assets/icons/play-button-icon.svg";
import asset_10 from "../assets/icons/accordian-expand.svg";
import asset_11 from "../assets/icons/accordian-collapse.svg";
import asset_12 from "../assets/icons/carousel-arrow-left.svg";
import asset_13 from "../assets/icons/carousel-arrow-right.svg";
import asset_14 from "../assets/icons/contact/footer-phone-icon.svg";
import asset_15 from "../assets/icons/contact/footer-email-icon.svg";
import asset_16 from "../assets/icons/contact/footer-location-icon.svg";
import asset_17 from "../assets/icons/social/facebook-icon.svg";
import asset_18 from "../assets/icons/social/twitter-icon.svg";
import asset_19 from "../assets/icons/social/instagram-icon.svg";
import asset_20 from "../assets/icons/social/pinterest-icon.svg";
import asset_21 from "../assets/icons/social/linkedin-icon.svg";
import asset_22 from "../assets/images/hero-seven/testimonial-card/inverted-comma.svg";
import asset_23 from "../assets/images/hero-five/hero-five-stage-icon-1.svg";
import asset_24 from "../assets/images/hero-five/hero-five-stage-icon-2.svg";
import asset_25 from "../assets/images/hero-five/hero-five-stage-icon-3.svg";
import asset_26 from "../assets/images/hero-five/hero-five-reward-icon-1.svg";
import asset_27 from "../assets/images/hero-five/hero-five-reward-icon-2.svg";
import asset_28 from "../assets/images/hero-five/hero-five-reward-icon-3.svg";
import asset_29 from "../assets/images/hero-five/hero-five-reward-icon-4.svg";
import asset_30 from "../assets/images/hero-five/hero-five-reward-icon-5.svg";
import asset_31 from "../assets/images/hero-five/hero-five-reward-icon-6.svg";
import asset_32 from "../assets/images/hero-five/hero-five-reward-icon-7.svg";
import asset_33 from "../assets/images/hero-five/hero-five-checkmark.svg";
import asset_34 from "../assets/images/hero-five/hero-five-checkmark-container-inactive.svg";
import asset_35 from "../assets/images/hero-five/hero-five-roundout-tab-edge-top.svg";
import asset_36 from "../assets/images/hero-five/hero-five-roundout-tab-edge-bottom.svg";
import asset_37 from "../assets/images/hero-six/schools/ribbon.svg";
import asset_38 from "../assets/images/hero-six/schools/step1-center-circle.svg";
import asset_39 from "../assets/images/hero-six/schools/step2-arrows-extend.svg";
import asset_40 from "../assets/images/hero-six/schools/step3-complete.svg";
import asset_41 from "../assets/images/hero-six/schools/schools.png";
import asset_42 from "../assets/images/hero-six/schools/mobile/row1col1.svg";
import asset_43 from "../assets/images/hero-six/schools/mobile/row1col2.svg";
import asset_44 from "../assets/images/hero-six/schools/mobile/row2col1.svg";
import asset_45 from "../assets/images/hero-six/schools/mobile/row2col2.svg";
import asset_46 from "../assets/images/hero-six/schools/mobile/row3col1.svg";
import asset_47 from "../assets/images/hero-six/schools/mobile/row3col2.svg";
import asset_48 from "../assets/images/hero-six/students/ribbon.svg";
import asset_49 from "../assets/images/hero-six/students/step1-center-circle.svg";
import asset_50 from "../assets/images/hero-six/students/step2-arrows-extend.svg";
import asset_51 from "../assets/images/hero-six/students/step3-complete.svg";
import asset_52 from "../assets/images/hero-six/students/students.png";
import asset_53 from "../assets/images/hero-six/students/mobile/row1col1.svg";
import asset_54 from "../assets/images/hero-six/students/mobile/row1col2.svg";
import asset_55 from "../assets/images/hero-six/students/mobile/row2col1.svg";
import asset_56 from "../assets/images/hero-six/students/mobile/row2col2.svg";
import asset_57 from "../assets/images/hero-six/students/mobile/row3col1.svg";
import asset_58 from "../assets/images/hero-six/students/mobile/row3col2.svg";
import asset_59 from "../assets/images/hero-six/parents/ribbon.svg";
import asset_60 from "../assets/images/hero-six/parents/step1-center-circle.svg";
import asset_61 from "../assets/images/hero-six/parents/step2-arrows-extend.svg";
import asset_62 from "../assets/images/hero-six/parents/step3-complete.svg";
import asset_63 from "../assets/images/hero-six/parents/parents.png";
import asset_64 from "../assets/images/hero-six/parents/mobile/row1col1.svg";
import asset_65 from "../assets/images/hero-six/parents/mobile/row1col2.svg";
import asset_66 from "../assets/images/hero-six/parents/mobile/row2col1.svg";
import asset_67 from "../assets/images/hero-six/parents/mobile/row2col2.svg";

export const PROJECT_ASSET_MAP: Record<string, string> = {
  "assets/shared/icons/phone-icon.svg": asset_0,
  "assets/shared/icons/arrow-right.svg": asset_1,
  "assets/shared/icons/download-icon.svg": asset_2,
  "assets/shared/icons/circle-yellow.svg": asset_3,
  "assets/shared/icons/vector-gray.svg": asset_4,
  "assets/shared/icons/vector-orange.svg": asset_5,
  "assets/shared/icons/rectangle-yellow.svg": asset_6,
  "assets/shared/icons/circle-purple.svg": asset_7,
  "assets/shared/icons/vector-red.svg": asset_8,
  "assets/shared/icons/play-button-icon.svg": asset_9,
  "assets/shared/icons/accordian-expand.svg": asset_10,
  "assets/shared/icons/accordian-collapse.svg": asset_11,
  "assets/shared/icons/carousel-arrow-left.svg": asset_12,
  "assets/shared/icons/carousel-arrow-right.svg": asset_13,
  "assets/shared/icons/footer-phone-icon.svg": asset_14,
  "assets/shared/icons/footer-email-icon.svg": asset_15,
  "assets/shared/icons/footer-location-icon.svg": asset_16,
  "assets/shared/icons/social/facebook-icon.svg": asset_17,
  "assets/shared/icons/social/twitter-icon.svg": asset_18,
  "assets/shared/icons/social/instagram-icon.svg": asset_19,
  "assets/shared/icons/social/pinterest-icon.svg": asset_20,
  "assets/shared/icons/social/linkedin-icon.svg": asset_21,
  "assets/home/hero-seven/testimonial-card/inverted-comma.svg": asset_22,
  "assets/shared/hero-five/hero-five-stage-icon-1.svg": asset_23,
  "assets/shared/hero-five/hero-five-stage-icon-2.svg": asset_24,
  "assets/shared/hero-five/hero-five-stage-icon-3.svg": asset_25,
  "assets/shared/hero-five/hero-five-reward-icon-1.svg": asset_26,
  "assets/shared/hero-five/hero-five-reward-icon-2.svg": asset_27,
  "assets/shared/hero-five/hero-five-reward-icon-3.svg": asset_28,
  "assets/shared/hero-five/hero-five-reward-icon-4.svg": asset_29,
  "assets/shared/hero-five/hero-five-reward-icon-5.svg": asset_30,
  "assets/shared/hero-five/hero-five-reward-icon-6.svg": asset_31,
  "assets/shared/hero-five/hero-five-reward-icon-7.svg": asset_32,
  "assets/shared/hero-five/hero-five-checkmark.svg": asset_33,
  "assets/shared/hero-five/hero-five-checkmark-container-inactive.svg": asset_34,
  "assets/shared/hero-five/hero-five-roundout-tab-edge-top.svg": asset_35,
  "assets/shared/hero-five/hero-five-roundout-tab-edge-bottom.svg": asset_36,
  "assets/home/hero-six/schools/ribbon.svg": asset_37,
  "assets/home/hero-six/schools/step1-center-circle.svg": asset_38,
  "assets/home/hero-six/schools/step2-arrows-extend.svg": asset_39,
  "assets/home/hero-six/schools/step3-complete.svg": asset_40,
  "assets/home/hero-six/schools/schools.png": asset_41,
  "assets/home/hero-six/schools/mobile/row1col1.svg": asset_42,
  "assets/home/hero-six/schools/mobile/row1col2.svg": asset_43,
  "assets/home/hero-six/schools/mobile/row2col1.svg": asset_44,
  "assets/home/hero-six/schools/mobile/row2col2.svg": asset_45,
  "assets/home/hero-six/schools/mobile/row3col1.svg": asset_46,
  "assets/home/hero-six/schools/mobile/row3col2.svg": asset_47,
  "assets/home/hero-six/students/ribbon.svg": asset_48,
  "assets/home/hero-six/students/step1-center-circle.svg": asset_49,
  "assets/home/hero-six/students/step2-arrows-extend.svg": asset_50,
  "assets/home/hero-six/students/step3-complete.svg": asset_51,
  "assets/home/hero-six/students/students.png": asset_52,
  "assets/home/hero-six/students/mobile/row1col1.svg": asset_53,
  "assets/home/hero-six/students/mobile/row1col2.svg": asset_54,
  "assets/home/hero-six/students/mobile/row2col1.svg": asset_55,
  "assets/home/hero-six/students/mobile/row2col2.svg": asset_56,
  "assets/home/hero-six/students/mobile/row3col1.svg": asset_57,
  "assets/home/hero-six/students/mobile/row3col2.svg": asset_58,
  "assets/home/hero-six/parents/ribbon.svg": asset_59,
  "assets/home/hero-six/parents/step1-center-circle.svg": asset_60,
  "assets/home/hero-six/parents/step2-arrows-extend.svg": asset_61,
  "assets/home/hero-six/parents/step3-complete.svg": asset_62,
  "assets/home/hero-six/parents/parents.png": asset_63,
  "assets/home/hero-six/parents/mobile/row1col1.svg": asset_64,
  "assets/home/hero-six/parents/mobile/row1col2.svg": asset_65,
  "assets/home/hero-six/parents/mobile/row2col1.svg": asset_66,
  "assets/home/hero-six/parents/mobile/row2col2.svg": asset_67,
};

export function resolveProjectAssetPath(cmsPath: string): string | undefined {
  return PROJECT_ASSET_MAP[cmsPath];
}
